import { createSalesPrice, getSalesPrice, getSalesPriceById, deleteSalesPrice } from '@/api/salesPriceRecord'
import Vue from 'vue'

import caclSalesCost from './caclSalesCost'


const state = {
  salesPriceRecordList: [],
  totalCounts: 0,
}

const actions = {

  async getSalesPriceAction({ commit }, payload) {
    try {
      const res = await getSalesPrice(payload)
      commit('SET_SALES_PRICE_RECORD', res.data)
      return res.data.salesPriceRecordList
    } catch (error) {
      throw error
    }
  },

  async createSalesPriceAction({ commit }, payload) {
    try {
      const newSalesPrice = await createSalesPrice(payload.form)
      newSalesPrice.data.rePrice = payload.form.price
      newSalesPrice.data.price = payload.form.price
      newSalesPrice.data.reSales = payload.form.sales
      newSalesPrice.data.startActiveDate = payload.form.startActiveDate
      commit('CREATE_SALES_PRICE_RECORD', newSalesPrice.data)
      return newSalesPrice.data
    } catch (error) {
      throw error
    }
  },

  async deleteSalesPriceAction({ commit }, payload) {
    try {
      await deleteSalesPrice(payload.id)
      commit('DELETE_SALES_PRICE', payload.id)
      return payload.id
    } catch (error) {
      throw error
    }
  }
}

const mutations = {
  SET_SALES_PRICE_RECORD(state, payload) {
    state.salesPriceRecordList = payload.salesPriceRecordList
    state.totalCounts = payload.totalCounts
  },

  CREATE_SALES_PRICE_RECORD(state, payload) {
    if (payload.reCalcSalesCost) {
      payload.sales.price = payload.sales.price.price
      state.salesPriceRecordList.unshift(payload.sales)
      state.totalCounts++
      Vue.set(caclSalesCost.state.salesLatestCost, caclSalesCost.state.salesLatestCost.findIndex(x => x._id === payload.sales._id), payload.sales)
    } else {
      state.salesPriceRecordList.unshift(payload)
      state.totalCounts++
      const index = caclSalesCost.state.salesLatestCost.findIndex(x => x._id === payload.reSales)
      const sales = caclSalesCost.state.salesLatestCost[index]
      sales.price = { price: payload.rePrice }
      Vue.set(caclSalesCost.state.salesLatestCost, index, sales)
    }
  },
  DELETE_SALES_PRICE(state, id) { 
    state.salesPriceRecordList = state.salesPriceRecordList.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}